import { MatDatepickerModule } from '@angular/material/datepicker';
// Custom DateAdapter
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatNativeDateModule, NativeDateAdapter, DateAdapter } from '@angular/material/core';
import moment, { Moment } from 'moment';
import { GlobalService } from '../services/global.service';
​
export class CustomDatePickerAdapter extends NativeDateAdapter {
  /**
   *
   * @param value
   */
  parse(value: string | number): Date | null {
    //Recupera la lingua corrente in modo da avere il locale corretto e lo imposta per l'istanza corrente di moment
    let currentLanguage = GlobalService.getSelectedLanguage();
    let localeMoment = moment().locale(currentLanguage.toLowerCase());
    let currentDateFormatted: Moment = null;
    if (localeMoment) {
      //Recupera il formato data legato al locale corrente impostato
      let dateFormat = localeMoment["_locale"]["_longDateFormat"]["L"];
​
      //Converte la stringa contenuta nel datePicker con moment
      currentDateFormatted = moment(value, dateFormat);
      return currentDateFormatted.isValid() == true ? currentDateFormatted.toDate() : null;
    }
    else
      return null;
  }
​
  format(date: Date, displayFormat: Object): string {
    if (date) {
      let currentLanguage = GlobalService.getSelectedLanguage();
      let localeMoment = moment().locale(currentLanguage.toLowerCase());
      if(moment(date).isValid() == true) {
        return moment(date).format(localeMoment["_locale"]["_longDateFormat"]["L"]);
      }
      else {
        return null;
      }
    }
    else
      return null;
  }
}
​
@NgModule({
  declarations: [],
  imports: [
  ],
  exports: [
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    {
      provide: DateAdapter, useClass: CustomDatePickerAdapter
    },
  ]
})
​
​
export class DatePickerModule {
​
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: DatePickerModule,
      providers: []
    }
  }
}
